import * as XLSX from 'xlsx';

/**
 * Export selected data to CSV or XLSX
 * @param {Object} options
 * @param {Array<Object>} options.data - Array of selected row objects
 * @param {Array<{label: string, key: string}>} [options.columns] - Optional column mapping
 * @param {string} [options.fileName='export'] - Filename without extension
 * @param {'csv'|'xlsx'} [options.format='xlsx'] - Export format
 */
export function exportData({ data, columns, fileName = 'export', format = 'xlsx' }) {
  const processedData = columns
    ? data.map(row => {
        const newRow = {};
        columns.forEach(({ label, key }) => {
          newRow[label] = row[key];
        });
        return newRow;
      })
    : data;

  const worksheet = XLSX.utils.json_to_sheet(processedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  const ext = format === 'csv' ? '.csv' : '.xlsx';
  const exportFileName = `${fileName}${ext}`;

  XLSX.writeFile(workbook, exportFileName, {
    bookType: format,
    type: 'binary',
  });
}
    